import { useState } from 'react';
import { cn, Collapse } from '@divlab/divanui';

import styles from './Questions.module.css';

import type { FC, HTMLAttributes } from 'react';

interface QuestionsProps extends HTMLAttributes<HTMLDivElement> {
  questions: QuestionsData;
}

export type QuestionsData = {
  title: string;
  items: {
    question: string;
    answer: string;
  }[];
};

const Questions: FC<QuestionsProps> = (props) => {
  const { className, questions, ...restProps } = props;
  const [openedQuestion, setOpenedQuestion] = useState<number>(null);

  const handleToggleQuestion = (index: number) => {
    setOpenedQuestion((prev) => (prev !== index ? index : null));
  };

  return (
    <div className={cn(styles.wrapper, className)} {...restProps}>
      <div className={styles.title}>{questions.title}</div>
      <div className={styles.questions}>
        {questions.items.map((question, index) => (
          <div
            className={cn(styles.item, {
              [styles.opened]: index === openedQuestion,
              [styles.hidden]: index !== openedQuestion,
            })}
            onClick={() => handleToggleQuestion(index)}
            key={question.question}
          >
            <div
              className={styles.question}
              dangerouslySetInnerHTML={{ __html: question.question }}
            />
            <Collapse duration={200} collapsed={index !== openedQuestion}>
              <div
                className={styles.answer}
                dangerouslySetInnerHTML={{ __html: question.answer }}
              />
            </Collapse>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Questions;
